// What a job's output shows as, shared by the job page, the studio's rows and My Generations.
import type { GenerationOutput } from "../../api/generated/model";

/** A preview's kind from the output's MIME type; `null` for a kind with no preview here. */
export function previewKind(output: GenerationOutput): "image" | "video" | null {
  if (output.mime?.startsWith("image/") === true) return "image";
  if (output.mime?.startsWith("video/") === true) return "video";
  return null;
}
